const transformConfigurableOptions = (configurable_options)=>configurable_options?.map(({ option_id , option_value  })=>{
        return {
            id: parseInt(option_id),
            value: parseInt(option_value)
        };
    }) || [];
const transformConfigurableOptionsRequest = (configurable_options)=>configurable_options ? configurable_options?.map(({ id , value  })=>({
            option_id: id,
            option_value: value.toString()
        })) : null;

export { transformConfigurableOptions, transformConfigurableOptionsRequest };
